<template>
  <a-spin tip="Loading..." :spinning="loading">
    <a-drawer
        placement="right"
        width="500"
        :closable="false"
        :visible="visible"
        :after-visible-change="afterVisibleChange"
        @close="onClose"
    >
      <a-descriptions title="派件基础信息" :column="2">
        <a-descriptions-item label="单号">{{ data.code }}</a-descriptions-item>
        <a-descriptions-item label="柜门">{{ data.cabinet.serial }}</a-descriptions-item>
        <a-descriptions-item label="入站同步">
          <a-tag color="#87d068" v-if="data.conectStatus.in">同步成功</a-tag>
          <a-tag color="#f50" v-else>同步失败</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="出站同步">
          <a-tag color="#87d068" v-if="data.conectStatus.out">同步成功</a-tag>
          <a-tag color="#f50" v-else>同步失败</a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="状态">
          <span v-if="data.status === 1">
            <a-badge status="success" />已取
          </span>
          <span v-if="data.status === 0">
            <a-badge status="processing" />未取
          </span>
          <span v-if="data.status === 2">
            <a-badge status="warning" />撤回
          </span>
        </a-descriptions-item>
        <a-descriptions-item label="信息">
           <span v-if="data.mtype === '0'">
            <a-icon type="mail" style="color: blue" />
            短信
          </span>
          <span v-if="data.mtype === '1'">
            <a-icon type="message" style="color: green" />
            微信
          </span>
          <span v-if="data.mtype === '11'">
            <a-icon type="info-circle" style="color: red" />
            发送失败
          </span>
          <span v-if="data.mtype === '9'">
            <a-icon type="clock-circle" style="color: red" />
            等等发送
          </span>
        </a-descriptions-item>
        <a-descriptions-item label="电话">{{ data.phone }}</a-descriptions-item>
        <a-descriptions-item label="投递时间">{{ data.intime }}</a-descriptions-item>
        <a-descriptions-item label="出站时间">{{ data.outtime }}</a-descriptions-item>
        <a-descriptions-item label="快递员">
          <excom-icon :excom="data.partner.pinyin" :text="data.partner.name" />
          {{ data.partner.mobile }}
        </a-descriptions-item>
      </a-descriptions>
      <a-descriptions title="操作日志" :column="1">
        <a-timeline>
          <a-timeline-item v-for="(item, index) in data.logs" :key="index">
            <p>{{ item.ctime }}({{ item.desc }})</p>
            <p>操作人：{{ item.opName }}</p>
          </a-timeline-item>
        </a-timeline>
      </a-descriptions>
      <div class="ant-descriptions-title">开箱记录</div>
      <a-table
            :loading="loading"
            size="small"
            :columns="columns"
            :data-source="cabinetLogs"
            :scroll="{ x:660, y: 500 }"
            :pagination="pager"
            @change="change">
          <span slot="sendResult" slot-scope="text, record">
          <a-tag color="#87d068" v-if="record.sendResult">成功</a-tag>
          <a-tooltip placement="top" v-else>
            <template slot="title">
              <span>{{ record.sendError }}</span>
            </template>
            <a-tag color="#f50">失败</a-tag>
          </a-tooltip>
        </span>
          <span slot="result" slot-scope="text, record">
          <a-tooltip placement="top">
            <template slot="title">
              <span>{{ record.responseText }}</span>
            </template>
            <a-tag color="green" v-if="record.result">成功</a-tag>
            <a-tag color="red" v-else>失败</a-tag>
          </a-tooltip>
        </span>
        </a-table>
    </a-drawer>
  </a-spin>
</template>

<script>
import { getPackageDetail } from '@/api/bussiness';
import { cabinetlog } from '@/api/cabinet';

const columns = [
  {
    title: '#',
    dataIndex: 'index',
    customRender: (text, row, index) => index + 1,
    key: 'index',
    width: '50px',
  },
  {
    title: '发送结果',
    dataIndex: 'sendResult',
    key: 'sendResult',
    scopedSlots: { customRender: 'sendResult' },
  },
  {
    title: '执行结果',
    dataIndex: 'result',
    key: 'result',
    scopedSlots: { customRender: 'result' },
  },
  {
    title: '类型',
    dataIndex: 'type',
    key: 'type',
  },
  {
    title: '发送时间',
    dataIndex: 'ctime',
    key: 'ctime',
  },
  {
    title: '返回时间',
    dataIndex: 'resTime',
    key: 'resTime',
  },
  {
    title: '差(ms)',
    dataIndex: 'difTime',
    key: 'difTime',
  },
  {
    title: '操作人',
    dataIndex: 'user.name',
    key: 'username',
    width: '120px',
  },
];
export default {
  name: 'detail.vue',
  data() {
    return {
      visible: false,
      loading: false,
      data: {
        conectStatus: {},
        partner: {},
        logs: [],
        cabinet: {},
      },
      columns,
      cabinetLogs: [],
      pager: {},
    };
  },
  created() {
  },
  methods: {
    onClose() {
      this.visible = false;
    },
    afterVisibleChange() {},
    show(id) {
      this.id = id;
      this.visible = true;
      this.detail();
    },
    async detail() {
      this.loading = true;
      try {
        const { data } = await getPackageDetail(this.id);
        const { data: { docs, pager } } = await cabinetlog({
          stationId: data.station,
          mailNo: data.code,
        });
        this.cabinetLogs = docs;
        this.pager = pager;
        this.data = data;
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    change() {},
  },
};
</script>

<style scoped>

</style>
